/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_Row_3Inputs */

const en_services_svc_full_art_row_3 = /** @type {(inputs: Services_Svc_Full_Art_Row_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model fallback used`)
};

const lv_services_svc_full_art_row_3 = /** @type {(inputs: Services_Svc_Full_Art_Row_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izmantots rezerves modelis`)
};

/**
* | output |
* | --- |
* | "Model fallback used" |
*
* @param {Services_Svc_Full_Art_Row_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_row_3 = /** @type {((inputs?: Services_Svc_Full_Art_Row_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_Row_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_row_3(inputs)
	return en_services_svc_full_art_row_3(inputs)
});